<script>
import VueJsonPretty from 'vue-json-pretty'
import NestedObject from './NestedObject'
export default {

  components: {
    VueJsonPretty
  },

  props: {
    flatObject: {}
  },

  computed: {
    jsonDefaults() {
      return NestedObject.build(this.flatObject)
    }
  },

  methods: {
    jsonClick() {

    }
  }

}
</script>

<template>
  <vue-json-pretty
    :path="''"
    :deep="1"
    :data="jsonDefaults"
    @click="jsonClick">
  </vue-json-pretty>
</template>

<style lang="scss">

</style>